import { useRouter } from 'next/router'
import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'

import { PageMetaData } from '@/components/atomic/PageMetaData'
import { Header } from '@/components/styleguide/Header'
import { SearchContentHeader } from '@/components/styleguide/SearchContentHeader'
import { SearchAdditionalPageContent } from '@/components/views/SearchAdditionalPageContent'
import { SearchResultsAndFilters } from '@/components/views/SearchResultsAndFilters'
import { constants } from '@/lib/constants'
import { getPageContentItemService } from '@/lib/services/pageService'
import { landedOnCarSearchPageWithPath } from '@/store/reducers/search'

const CarManufacturerPage = ({ pageContent }) => {
  const router = useRouter()
  const dispatch = useDispatch()
  const [status, setStatus] = useState(constants.componentStatus.LOADING)
  const [showPageContent, setShowPageContent] = useState(true)

  useEffect(() => {
    // Hide page content if the user has paginated
    if (router.query.page) {
      setShowPageContent(false)
    }
  }, [router.query.page])

  useEffect(() => {
    setStatus(constants.componentStatus.LOADING)
    dispatch(landedOnCarSearchPageWithPath(router.asPath))
  }, [router, dispatch])

  return (
    <>
      <PageMetaData
        title={pageContent.pageTitle}
        pageTitle={pageContent.pageTitle}
        description={pageContent.metaDescription}
        pageUrl={router.asPath.split('?')[0]}
        canonical={`${process.env.NEXT_PUBLIC_URL}${router.asPath.split('?')[0]}`}
        image={pageContent.image}
        noIndex={router.asPath.includes('page=')}
      />
      <Header
        width="browse"
        backgroundColor="backdrop"
        hasBorderBottom="desktop"
        hideNav="mobile"
      />
      {showPageContent && (
        <SearchContentHeader
          isVans={false}
          pageContent={pageContent}
        />
      )}
      <SearchResultsAndFilters
        isVans={false}
        setStatus={setStatus}
        status={status}
      />
      <SearchAdditionalPageContent pageContent={pageContent} />
    </>
  )
}

export default CarManufacturerPage

export const getServerSideProps = async context => {
  try {
    const contentResponse = await getPageContentItemService({
      type: 'BANNER',
      page: '1',
      urlKey: `car-leasing/${context.params.manufacturer}`,
    })

    const pageContent = { ...contentResponse.content, urlKey: contentResponse.urlKey }

    return {
      props: {
        pageContent,
      },
    }
  } catch (err) {
    return {
      notFound: true,
    }
  }
}
